import { ReactNode } from "react";
import {
  Typography as AntdTypographyComponent,
  TypographyProps as AntdTypographyProps,
} from "antd";
import { BaseComponentProps, Variant, Size } from "../types";
import "./AntdTypography.scss";

const { Title, Paragraph, Text, Link } = AntdTypographyComponent;

export interface BaseTypographyProps
  extends Omit<AntdTypographyProps, "children">,
    BaseComponentProps {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
}

export interface AntdLinkProps extends BaseComponentProps {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
  onClick?: () => void;
  underline?: boolean;
}

export const AntdTypography: React.FC<BaseTypographyProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  ...props
}) => {
  const typographyClass = [
    "antd-typography",
    `antd-typography--${variant}`,
    `antd-typography--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <AntdTypographyComponent
      className={typographyClass}
      data-testid={testId}
      {...props}
    >
      {children}
    </AntdTypographyComponent>
  );
};

// 子组件
export const AntdTitle: React.FC<BaseTypographyProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  ...props
}) => {
  const titleClass = [
    "antd-title",
    `antd-title--${variant}`,
    `antd-title--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Title className={titleClass} data-testid={testId} {...props}>
      {children}
    </Title>
  );
};

export const AntdParagraph: React.FC<BaseTypographyProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  ...props
}) => {
  const paragraphClass = [
    "antd-paragraph",
    `antd-paragraph--${variant}`,
    `antd-paragraph--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Paragraph className={paragraphClass} data-testid={testId} {...props}>
      {children}
    </Paragraph>
  );
};

export const AntdText: React.FC<BaseTypographyProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  ...props
}) => {
  const textClass = [
    "antd-text",
    `antd-text--${variant}`,
    `antd-text--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Text className={textClass} data-testid={testId} {...props}>
      {children}
    </Text>
  );
};

export const AntdLink: React.FC<AntdLinkProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  onClick,
  underline = false,
  ...props
}) => {
  const linkClass = [
    "antd-link",
    `antd-link--${variant}`,
    `antd-link--${size}`,
    underline && "antd-link--underline",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Link
      className={linkClass}
      data-testid={testId}
      underline={underline}
      onClick={onClick}
      {...props}
    >
      {children}
    </Link>
  );
};

export default AntdTypography;
